import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useLang } from "../contexts/LanguageContext";
import CarCard from "../components/CarCard";

export default function Favorites() {
  const { t } = useLang();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.listFavorites().then(setItems).finally(() => setLoading(false));
  }, []);

  return (
    <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
      <h1 className="font-display text-3xl font-bold text-white sm:text-4xl">{t.fav.title}</h1>
      {loading ? (
        <div className="mt-10 h-40 animate-pulse rounded-lg border border-zinc-800 bg-zinc-950" />
      ) : items.length === 0 ? (
        <div className="mt-10 rounded-lg border border-dashed border-zinc-800 p-16 text-center text-zinc-500">{t.fav.empty}</div>
      ) : (
        <div className="mt-10 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
          {items.map((c) => <CarCard key={c.id} car={c} />)}
        </div>
      )}
    </div>
  );
}
